import { useFormContext } from 'react-hook-form';
import { TarifStep } from '../steps/tarif-step';
import { useUnifiedTarifConfig } from './hook';
import type { TarifPageVariant } from './types';

interface UnifiedTarifStepProps {
    variant: TarifPageVariant;
    afterOptionsSlot?: React.ReactNode;
    beforeRecapSlot?: React.ReactNode;
}

export function UnifiedTarifStep({ variant, afterOptionsSlot, beforeRecapSlot }: UnifiedTarifStepProps) {
    const config = useUnifiedTarifConfig({ variant });
    const methods = useFormContext();

    // Utiliser FormulePreconisee de l'API si disponible (pour les avenants notamment)
    // Sinon fallback sur la formule par défaut du variant
    const Tarif = methods.watch('Tarif');
    const defaultFormule = Tarif?.FormulePreconisee || variant.defaultFormule;

    return (
        <TarifStep
            config={config}
            defaultFormule={defaultFormule}
            optionCode={variant.optionCode}
            tarifVariant={variant.variant}
            fractionnement={variant.fractionnement}
            afterOptionsSlot={afterOptionsSlot}
            beforeRecapSlot={beforeRecapSlot}
            commissionConfig={variant.commissionConfig}
        />
    );
}
